module.exports = __webpack_public_path__ + "media/bootstrap-icons/stack-2195f911.svg";